export default __webpack_public_path__ + "static/media/Levitate D2.2 Project leaflet.254fd494.pdf";